module.exports = __webpack_public_path__ + "img/interactive-fountain-fallback.69d410a2.png";